if (!customElements.get('bash-studio-page')) {
  customElements.define('bash-studio-page', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return
      this.ready = true
      this.abort = new AbortController()
      this.signal = this.abort.signal
      this.setupPreview()
      this.setupContents()
      this.setupBrands()
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return
        const details = event.target.closest('details')
        if (details) details.open = true
      }, {signal:this.signal})
    }
    disconnectedCallback() {
      this.abort?.abort()
      this.ready = false
    }
    setupPreview() {
      const preview = this.querySelector('[data-bps-preview]')
      if (!preview) return
      const choices = [...preview.querySelectorAll('[data-bps-width]')]
      const apply = width => {
        if (width === 'desktop') this.removeAttribute('data-bps-preview-width')
        else this.dataset.bpsPreviewWidth = width
        choices.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.bpsWidth === width)))
      }
      const initial = location.hash.match(/^#page-preview-(desktop|tablet|mobile)$/)?.[1] || 'desktop'
      apply(initial)
      const shareUrl = new URL(location.href)
      shareUrl.searchParams.set('preview_theme_id','197416059254')
      shareUrl.searchParams.set('pb','0')
      history.replaceState(history.state,'',shareUrl)
      choices.forEach(button => button.addEventListener('click', () => {
        apply(button.dataset.bpsWidth)
        const url = new URL(location.href)
        url.hash = 'page-preview-' + button.dataset.bpsWidth
        history.replaceState(history.state,'',url)
      }, {signal:this.signal}))
    }
    setupContents() {
      const nav = this.querySelector('[data-bps-toc]')
      const target = this.querySelector('[data-bps-toc-links]')
      const copy = this.querySelector('[data-bps-copy]')
      if (!nav || !target || !copy) return
      target.replaceChildren()
      const headings = [...copy.querySelectorAll('h2')]
      headings.forEach((heading,index) => {
        if (!heading.id) heading.id = this.closest('[id]')?.id + '-chapter-' + (index+1)
        const a = document.createElement('a')
        a.href = '#' + heading.id
        a.textContent = heading.textContent
        target.append(a)
      })
      nav.hidden = headings.length === 0
    }
    setupBrands() {
      const directory = this.querySelector('[data-bps-brands]')
      if (!directory) return
      const input = directory.querySelector('[data-bps-filter]')
      const reset = directory.querySelector('[data-bps-reset]')
      const list = directory.querySelector('[data-bps-brand-list]')
      const cards = [...list.querySelectorAll('[data-bps-vendor]')]
      const letters = [...directory.querySelectorAll('[data-bps-letter]')]
      const status = directory.querySelector('[data-bps-count]')
      const more = directory.querySelector('[data-bps-more]')
      const empty = directory.querySelector('[data-bps-empty]')
      const size = Number(directory.dataset.batch) || 48
      const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase().trim()
      let selected = 'all'
      let limit = size
      const update = () => {
        const query = normalize(input.value)
        const matching = cards.filter(card => normalize(card.dataset.bpsVendor).includes(query) && (selected === 'all' || card.dataset.bpsInitial === selected))
        const visible = new Set(matching.slice(0,limit))
        cards.forEach(card => {card.hidden = !visible.has(card)})
        letters.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.bpsLetter === selected)))
        status.textContent = directory.dataset.countLabel.replace('[shown]',String(visible.size)).replace('[total]',String(matching.length))
        empty.hidden = matching.length > 0
        more.hidden = visible.size >= matching.length
        reset.hidden = !input.value && selected === 'all'
        return matching
      }
      letters.forEach(button => {
        button.disabled = button.dataset.bpsLetter !== 'all' && !cards.some(card => card.dataset.bpsInitial === button.dataset.bpsLetter)
        button.addEventListener('click', () => {
          selected = button.dataset.bpsLetter
          limit = size
          update()
        }, {signal:this.signal})
      })
      input.addEventListener('input', () => {selected='all';limit=size;update()}, {signal:this.signal})
      reset.addEventListener('click', () => {input.value='';selected='all';limit=size;update();input.focus()}, {signal:this.signal})
      more.addEventListener('click', () => {
        const previous = limit
        limit += size
        const matching = update()
        matching[previous]?.querySelector('a')?.focus({preventScroll:true})
      }, {signal:this.signal})
      directory.querySelectorAll('[data-bps-quick]').forEach(button => {
        if (!cards.some(card => normalize(card.dataset.bpsVendor) === normalize(button.dataset.bpsQuick))) {button.hidden=true;return}
        button.addEventListener('click', () => {input.value=button.dataset.bpsQuick;selected='all';limit=size;update();input.focus()}, {signal:this.signal})
      })
      const featured = directory.querySelector('[data-bps-featured]')
      if (featured && ![...featured.querySelectorAll('button')].some(button=>!button.hidden)) featured.hidden=true
      directory.querySelector('[data-bps-alphabet]').hidden=false
      update()
    }
  })
}
